import React from 'react';
export default function TestePage() {
  return <div style={{background:'#f0f',padding:32}}>TESTE PAGE</div>;
} 